import React from 'react'
import SidebarButton from '../../components/sidebar/SidebarButton'
import SidebarSection from '../../components/sidebar/SidebarSection'
import { useSelector } from '../../store/hooks'
import { usePropertyOverlay } from '../../store/hooks/uiExpertHooks'

type SidebarGlobalPropertySectionProps = {
  onSectionChange?: (nextSection: string) => unknown
}
const SidebarGlobalPropertySection: React.FC<SidebarGlobalPropertySectionProps> = ({ onSectionChange }) => {
  const sections = useSelector((state) => state.data.menu) ?? []
  const { globalSection, setGlobalSection } = usePropertyOverlay()

  return (
    <SidebarSection>
      {sections.map(({ id, displayName, icon }) => (
        <SidebarButton
          key={id}
          icon={icon}
          active={id === globalSection}
          onClick={(e) => {
            ;(e.target as HTMLElement).blur()
            setGlobalSection(id)
            onSectionChange?.(id)
          }}
        >
          {displayName}
        </SidebarButton>
      ))}
    </SidebarSection>
  )
}

export default SidebarGlobalPropertySection
